import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const VisitorsAreaChart = ({ data = [], title = "Visitor Insight" }) => {
  return (
    <div className="home-analysis-card area-card-home">
      <div className="home-chart-title">{title}</div>
      <div className="home-chart-wrapper">
        <ResponsiveContainer width="100%" height={340}>
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorVisitors" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.9} />
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="label" tick={{ fill: '#64748b', fontSize: 12 }} tickLine={false} />
            <YAxis tick={{ fill: '#64748b', fontSize: 12 }} tickLine={false} />
            <Tooltip 
              contentStyle={{
                backgroundColor: '#fff',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)'
              }}
            />
            <Area
              type="natural"
              dataKey="visitors"
              stroke="#2563eb"
              strokeWidth={3}
              fill="url(#colorVisitors)"
              animationDuration={1600}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default VisitorsAreaChart;